import { createFileRoute, Outlet } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod';

import { SettingsLayout } from '#modules/user/features/profile/components/Settings/SettingsLayout';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings'
)({
  component: LayoutComponent,
  validateSearch: zodValidator(
    z.object({
      /**
       * Метка «только что зарегистрировался» приезжает в двух видах, и оба обязаны проходить.
       * Переход внутри приложения кладёт в состояние строку `'true'`, а разбор адреса (прямой
       * заход, перезагрузка, редирект из teamplay-user после OAuth) отдаёт уже boolean `true`.
       * Пока схема принимала только строку, второй случай ронял настройки в «Страница не
       * загрузилась» — поэтому бэкенд и слал `newUser='true'` в кавычках, чтобы значение не
       * распозналось как boolean. Разбираем метку в `useIsNewUser`.
       */
      newUser: z.union([z.boolean(), z.string()]).optional(),
    })
  ),
  ssr: false,
});

function LayoutComponent() {
  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
}
